const messageList = () => import('@/pages/message/index.vue');
const messageForm = () => import('@/pages/message/form.vue');

export default [{
    path: '/message',
    component: messageList,
    meta: [{
        name: '消息通知'
    },
    {
        name: '消息管理',
        activeRoute: '/message'
    }]
}, {
    path: '/message/form',
    component: messageForm,
    meta: [{
        name: '消息通知'
    },
    {
        name: '消息管理',
        url: '/message',
    },
    {
        name: '添加/编辑',
        activeRoute: '/message'
    }]
}];